import {
  getTrackerTypeLabel,
  TRACKER_TYPES,
} from './trackerTypes';

export const TRACKER_CANDIDATE_KINDS = Object.freeze({
  TRACKABLE_TARGET: 'trackable_target',
});

const buildTrackerEntry = (type) => Object.freeze({
  type,
  label: getTrackerTypeLabel(type),
  kind: TRACKER_CANDIDATE_KINDS.TRACKABLE_TARGET,
});

export const trackerCandidateRegistry = Object.freeze({
  [TRACKER_TYPES.GOAL]: buildTrackerEntry(TRACKER_TYPES.GOAL),
  [TRACKER_TYPES.BEHAVIOR]: buildTrackerEntry(TRACKER_TYPES.BEHAVIOR),
  [TRACKER_TYPES.MEDICATION_EFFECT]: buildTrackerEntry(TRACKER_TYPES.MEDICATION_EFFECT),
  [TRACKER_TYPES.HEALTH_SYMPTOM]: buildTrackerEntry(TRACKER_TYPES.HEALTH_SYMPTOM),
  [TRACKER_TYPES.SUPPORT_STRATEGY]: buildTrackerEntry(TRACKER_TYPES.SUPPORT_STRATEGY),
  [TRACKER_TYPES.ROUTINE_HABIT]: buildTrackerEntry(TRACKER_TYPES.ROUTINE_HABIT),
});

export const getTrackerCandidateAdapter = (type = '') => {
  const adapter = trackerCandidateRegistry[String(type || '').trim()];
  if (!adapter) {
    throw new Error(`No tracker candidate adapter registered for "${type}".`);
  }
  return adapter;
};
